import { action, makeObservable, observable } from 'mobx';
import { Util } from 'utils/common.utils';

export class GlobalUIStore {
  private static globalUIStore: GlobalUIStore;

  screenWidth = Util.GetScreenWidth();

  private constructor() {
    window.addEventListener("resize", this.handleResize);

    makeObservable(this, {
      screenWidth: observable,
      changeScreenWidth: action,
    });
  }

  public static get GetInstance() {
    if (!this.globalUIStore) {
      this.globalUIStore = new GlobalUIStore();
    }

    return this.globalUIStore;
  }

  changeScreenWidth(newSize: number) {
    this.screenWidth = newSize;

  }

  private handleResize = () => {
    const newSize = Util.GetScreenWidth();
    if (this.screenWidth !== newSize) {
      this.changeScreenWidth(newSize);
    }
  };
}